import React, { useState, useEffect } from "react";
import { Form, Button, Table } from "antd";
import { FormItemTypeEnum } from "../../../../components2/YhFormBox/Types"
import { YhFormItemsBox } from "../../../../components2/YhFormBox"
import { useSupplierModel } from "../supplierModel"
import useMdmModel from "../../../../model/mdmModel"
import { useNavModel } from "../../../../model/navModel";
import { DetailType } from "../../../../types/FmsEnums";
import { ISupplierDetail, ISupplierInsert, ISupplierUpdata } from "../supplierTypes"
import { setTitle, loadDictParam, findOption } from "../../../../utils/utils"
import { DictEnum } from "../../../../types/MdmDIctEnum";

const SuppliergDetail = () => {
    const [form] = Form.useForm();
    const { mdmBranch, mdmOrgan, dict, userAll, shop } = useMdmModel();
    const { selectedNavId, getSelectedNavState, replaceNav } = useNavModel()
    const { addParam, bankList, supplierList, selectedRow, setBankList, setSupplierList, setAddParam, setSelectedRow, updataAddParam, updataEditParam, insertDetail, updataDetail } = useSupplierModel()
    const [modes] = useState<any>(getSelectedNavState("state"));
    const { id, pageParams: { mode, id: ids } } = modes

    useEffect(() => {
        if (mode == DetailType.add) {
            form.setFieldsValue(addParam)
        } else if (mode == DetailType.edit || mode == DetailType.look) {
            let editRow = selectedRow[0] ?? {};
            //转换成 门店 或者用户的数据
            let res = {
                ...editRow,
                shopSuppliers: editRow.shopSuppliers?.map((item: any) => typeof item === "string" ? item : item.code) ?? [],
                userSuppliers: editRow.userSuppliers?.map((item: any) => typeof item === "string" ? item : item.code) ?? []
            }
            selectedRow[0] && form.setFieldsValue(res);
        }
    }, [])

    const onFinish = (values: ISupplierInsert | ISupplierUpdata) => {
        let newValue = {
            ...values,
            shopSuppliers: values?.shopSuppliers ? values?.shopSuppliers?.map((item: any) => ({
                "code": findOption(item as string, shop)?.value,
                "name": findOption(item as string, shop)?.label
            })) : [],
            userSuppliers: values.userSuppliers ? values.userSuppliers?.map((item: any) => ({
                "code": findOption(item as string, userAll)?.value,
                "name": findOption(item as string, userAll)?.label
            })) : [],
        }
        if (mode == DetailType.add) {
            insertDetail(newValue as ISupplierInsert).then(res => res && close())
        } else if (mode == DetailType.edit) {
            updataDetail(newValue as ISupplierDetail).then(res => res && close())
        }
    }

    useEffect(() => {
        setBankList(loadDictParam(DictEnum.ACC_BACK, dict))
        setSupplierList(loadDictParam(DictEnum.SUPPLIER_TYPE, dict))
    }, [])


    const close = () => {
        replaceNav(selectedNavId, "2-9")
    }

    const items = [
        {
            type: FormItemTypeEnum.Select,
            span: 6,
            fieldLabel: "分支编码",
            labelCol: { span: 6 },
            fieldName: "branch",
            options: mdmBranch
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "版本号",
            labelCol: { span: 6 },
            fieldName: "ver",
            disable: true,
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "供应商编码",
            labelCol: { span: 6 },
            fieldName: "code",
            disable: mode == DetailType.edit
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "供应商名称",
            labelCol: { span: 6 },
            fieldName: "name",
            rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "英文名称",
            labelCol: { span: 6 },
            fieldName: "nameEn",
        },
        {
            type: FormItemTypeEnum.Select,
            span: 6,
            fieldLabel: "供应商类型",
            labelCol: { span: 6 },
            fieldName: "categoryCode",
            options: supplierList
        }, {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "联系人",
            labelCol: { span: 6 },
            fieldName: "contact",
        }, {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "联系电话",
            labelCol: { span: 6 },
            fieldName: "phone",
        }, {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "联系地址",
            labelCol: { span: 6 },
            fieldName: "address",
        }, {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "传真号码",
            labelCol: { span: 6 },
            fieldName: "fax",
        }, {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "电子邮箱",
            labelCol: { span: 6 },
            fieldName: "email",
        }, {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "公司网址",
            labelCol: { span: 6 },
            fieldName: "website",
        }, {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "办公电话",
            labelCol: { span: 6 },
            fieldName: "tel",
        },
        {
            type: FormItemTypeEnum.TreeSelect,
            span: 6,
            fieldLabel: "所属机构",
            labelCol: { span: 6 },
            fieldName: "orgName",
            treeData: mdmOrgan
        },
        // {
        //     type: FormItemTypeEnum.Input,
        //     span: 6,
        //     fieldLabel: "机构编码",
        //     labelCol: { span: 6 },
        //     fieldName: "orgCode",
        // },  
        {
            type: FormItemTypeEnum.Input,
            span: 12,
            fieldLabel: "备注",
            labelCol: { span: 3 },
            fieldName: "note",
        },
        {
            type: FormItemTypeEnum.Select,
            span: 6,
            mode: "multiple",
            fieldLabel: "关联门店",
            labelCol: { span: 6 },
            fieldName: "shopSuppliers",
            options: shop,
        },
        {
            type: FormItemTypeEnum.Select,
            span: 6,
            fieldLabel: "关联用户",
            labelCol: { span: 6 },
            mode: "multiple",
            fieldName: "userSuppliers",
            options: userAll,
        },
    ]
    const items2 = [
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "发票抬头",
            labelCol: { span: 6 },
            fieldName: "invoiceTitle",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "英文发票抬头",
            labelCol: { span: 6 },
            fieldName: "invoiceTitleEn",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "营业执照",
            labelCol: { span: 6 },
            fieldName: "licenseNo",
        },
        {
            type: FormItemTypeEnum.Select,
            span: 6,
            fieldLabel: "开户银行",
            labelCol: { span: 6 },
            fieldName: "bank",
            options: bankList
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "银行账户",
            labelCol: { span: 6 },
            fieldName: "bankAcct",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "邮寄地址",
            labelCol: { span: 6 },
            fieldName: "postAddress",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "邮寄英文地址",
            labelCol: { span: 6 },
            fieldName: "postAddressEn",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "公司法人",
            labelCol: { span: 6 },
            fieldName: "corporation",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "公司英文法人",
            labelCol: { span: 6 },
            fieldName: "corporationEn",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "经营范围",
            labelCol: { span: 6 },
            fieldName: "businessScope",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "经营英文范围",
            labelCol: { span: 6 },
            fieldName: "businessScopeEn",
        },
        {
            type: FormItemTypeEnum.Switch,
            span: 6,
            fieldLabel: "状态",
            labelCol: { span: 6 },
            fieldName: "enable",
            valuePropName: "checked",
            checkedChildren: "启用",
            unCheckedChildren: "禁用"
        },
    ]
    const items3 = [
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "创建人",
            labelCol: { span: 6 },
            fieldName: "createUser",
            disable: true
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "创建时间",
            labelCol: { span: 6 },
            fieldName: "createTime",
            disable: true
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "修改人",
            labelCol: { span: 6 },
            fieldName: "updateUser",
            disable: true
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "修改时间",
            labelCol: { span: 6 },
            fieldName: "updateTime",
            disable: true
        },
    ]
    const title = <div className="font-bold font-size-lg">{setTitle(mode)}供应商</div>
    const title2 = <div className="font-bold font-size-lg">开票信息</div>
    const title3 = <div className="font-bold font-size-lg">其他信息</div>

    const reset = () => {
        form.resetFields()
        if (mode == DetailType.add) {
            setAddParam({})
        } else if (mode == DetailType.edit) {
            form.setFieldsValue({ code: selectedRow[0].code })
            setSelectedRow([{ code: selectedRow[0].code }])
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => form.submit()}
        >保存</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => reset()}
        >重置</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => close()}
        >取消</Button>
    </>
    return <Form
        form={form}
        onValuesChange={mode == DetailType.add ? updataAddParam : updataEditParam}
        onFinish={onFinish}
    >
        <YhFormItemsBox disabled={mode == DetailType.look} items={items} title={title} action={action} IclassName="p-20" />
        <YhFormItemsBox disabled={mode == DetailType.look} items={items2} title={title2} IclassName="p-20" />
        <YhFormItemsBox disabled={mode == DetailType.look} items={items3} title={title3} IclassName="p-20" />
    </Form>
}
export default SuppliergDetail